import { Component, ElementRef, EventEmitter, Output, Input, NgZone, ViewChild } from '@angular/core';

import { SnackbarService } from '../../services/snackbar.service';
import { SessionStorageService } from '../../services/session-storage.service';
import { SharedService } from '../../services/shared.service';
import { StripeAddNewPaymentService } from './stripe-add-new-payment.service';

import { config } from '../../../../../config';
declare let Stripe: any;

@Component({
    selector: 'stripe-add-new-payment',
    template: require('./stripe-add-new-payment.component.html'),
    styles: [require('./stripe-add-new-payment.component.less')],
    providers: [SharedService, SessionStorageService, SnackbarService, StripeAddNewPaymentService],
    preserveWhitespaces: true
})

export class StripeAddNewPaymentComponent {
    @ViewChild('cardNumberElement', { static: false }) cardNumberElement!: ElementRef;
    @ViewChild('cardExpiryElement', { static: false }) cardExpiryElement!: ElementRef;
    @ViewChild('cardCvcElement', { static: false }) cardCvcElement!: ElementRef;
    @ViewChild('cardErrors', { static: false }) cardErrors!: ElementRef;

    @Input() submitClicked: boolean = false;
    @Input() cardDeclined: boolean = false;
    @Input() makePrimary: boolean = false;
    @Output() onCardSaveEvent: EventEmitter<any> = new EventEmitter();
    @Output() errorSaveCardEvent: EventEmitter<any> = new EventEmitter();
    @Output() onCardValidation: EventEmitter<any> = new EventEmitter();
    @Output() onCardChange: EventEmitter<any> = new EventEmitter();
    @Output() onCardComplete: EventEmitter<any> = new EventEmitter();
    @Output() onPaymentIntentStart: EventEmitter<void> = new EventEmitter();
    @Output() onCardDeclined: EventEmitter<any> = new EventEmitter();
    nameError: boolean = false;
    cardData: any = {
        name: ''
    };

    Stripe3: any;
    elements: any;
    errorElement: any;
    card: any;
    cardNumber: any;
    cardCvc: any;
    cardExpiry: any;
    cvcImgSrc: string = '';
    cardOption: any;
    clientSecret: string = '';
    cardBrandSources: any = {
        'visa': 'https://js.stripe.com/v3/fingerprinted/img/visa-365725566f9578a9589553aa9296d178.svg',
        'mastercard': 'https://js.stripe.com/v3/fingerprinted/img/mastercard-4d8844094130711885b5e41b28c9848f.svg',
        'amex': 'https://js.stripe.com/v3/fingerprinted/img/amex-a49b82f46c5cd6a96a6e418a6ca1717c.svg',
        'discover': 'https://js.stripe.com/v3/fingerprinted/img/discover-ac52cd46f89fa40a29a0bfb954e33173.svg',
        'diners': 'https://js.stripe.com/v3/fingerprinted/img/diners-fbcbd3360f8e3f629cdaa80e93abdb8b.svg',
        'jcb': 'https://js.stripe.com/v3/fingerprinted/img/jcb-271fd06e6e7a2c52692ffa91a95fb64f.svg',
        'unionpay': 'https://js.stripe.com/v3/fingerprinted/img/unionpay-8a10aefc7295216c338ba4e1224627a1.svg'
    };
    cvcSources: any = {
        'amex': 'https://stripe.com/img/v3/elements/overview/experience/card-icon-cvc-amex.svg',
        'other': 'https://stripe.com/img/v3/elements/overview/experience/card-icon-cvc.svg'
    };

    cardComplete: any = {
        'cardNumber': false,
        'cardExpiry': false,
        'cardCvc': false
    };

    cardError: any = {
        cardNumber: false,
        cardExpiry: false,
        cardCvc: false
    };
    cardErrorMessages: any = {
        cardNumber: '',
        cardExpiry: '',
        cardCvc: ''
    };
    cardTypeImgSrc: string = '';
    isStripeLoaded: boolean = false;
    private lastCardValidationError: boolean | undefined;
    private lastCardComplete: boolean | undefined;

    cardStyle = {
        base: {
            fontSize: '14px',

            '::placeholder': {
                color: '#737171',
                fontSize: '14px'
            }
        }
    };

    constructor(private readonly _stripeAddNewPaymentService: StripeAddNewPaymentService,
        public _mdlSnackbarService: SnackbarService,
        private readonly _ngZone: NgZone,
    ) { }

    ngAfterViewInit() {
        this.setupStripe();
    }

    setupStripe() {
        this.Stripe3 = Stripe(config.StripeKey);
        setTimeout(() => { this.isStripeLoaded = true; });
        this.elements = this.Stripe3.elements();
        this.errorElement = this.cardErrors.nativeElement;
        this.cvcImgSrc = this.cvcSources['other'];

        this.cardNumber = this.elements.create('cardNumber', { style: this.cardStyle });
        this.cardNumber.mount(this.cardNumberElement.nativeElement);

        this.cardExpiry = this.elements.create('cardExpiry', { style: this.cardStyle });
        this.cardExpiry.mount(this.cardExpiryElement.nativeElement);

        this.cardCvc = this.elements.create('cardCvc', { style: this.cardStyle });
        this.cardCvc.mount(this.cardCvcElement.nativeElement);

        this.cardChangesHandler();
    }

    // to display stripe element's errors
    cardChangesHandler() {
        let cardItems = ['cardNumber', 'cardExpiry', 'cardCvc'];
        cardItems.forEach((cardItem: any) => {
            this[cardItem].on('change', (event: any) => {
                if (event.brand) {
                    if (this.cardDeclined) {
                        this.cardDeclined = false;
                    }
                    this.cardTypeImgSrc = this.cardBrandSources[event.brand];
                    this.cvcImgSrc = (event.brand === 'amex') ? this.cvcSources['amex'] : this.cvcSources['other'];
                }

                this.cardComplete[cardItem] = event.complete;

                if (event.error) {
                    this.cardError[cardItem] = true;
                    this.cardErrorMessages[cardItem] = event.error.message;
                    this.emitCardValidation(true);
                } else {
                    this.cardError[cardItem] = false;
                    this.cardErrorMessages[cardItem] = '';
                    this.emitCardValidation(false);
                }

                // Update error message with priority: cardNumber > cardExpiry > cardCvc
                this.updateErrorMessage();
                this.onCardChange.emit();
                this.emitCompleteStatus();
            });
        });
    }

    emitCardValidation(hasError: boolean) {
        if (this.lastCardValidationError !== hasError) {
            this.lastCardValidationError = hasError;
            this.onCardValidation.emit({ error: hasError });
        }
    }

    emitCompleteStatus() {
        const isComplete = !!(this.cardComplete.cardNumber && this.cardComplete.cardExpiry && this.cardComplete.cardCvc && this.cardData.name.trim());

        if (this.lastCardComplete !== isComplete) {
            this.lastCardComplete = isComplete;
            this.onCardComplete.emit(isComplete);
        }
    }

    // Display error message with priority order
    updateErrorMessage() {
        const priorityOrder = ['cardNumber', 'cardExpiry', 'cardCvc'];

        for (const field of priorityOrder) {
            if (this.cardError[field] && this.cardErrorMessages[field]) {
                this.errorElement.textContent = this.cardErrorMessages[field];
                return;
            }
        }

        // No errors - clear the message
        this.errorElement.textContent = null;
    }

    validatecardDetails() {
        const priorityOrder = [
            { field: 'cardNumber', message: 'Your card number is incomplete.' },
            { field: 'cardExpiry', message: 'Your expiration date is incomplete.' },
            { field: 'cardCvc', message: 'Your security code is incomplete.' }
        ];
        let cardErrorMessage = '';

        priorityOrder.forEach((cardField: any) => {
            if (!this.cardComplete[cardField.field]) {
                this.cardError[cardField.field] = true;
                this.cardErrorMessages[cardField.field] = this.cardErrorMessages[cardField.field] || cardField.message;
                cardErrorMessage = cardErrorMessage || this.cardErrorMessages[cardField.field];
            } else {
                this.cardError[cardField.field] = false;
                this.cardErrorMessages[cardField.field] = '';
            }
        });
        this.updateErrorMessage();

        if (!this.cardData.name || this.cardData.name.trim() === '') {
            this.nameError = true;
            return { hasError: true, errorMessage: 'FILL_REQUIRED_DETAILS' };
        }

        return { hasError: !!cardErrorMessage, errorMessage: cardErrorMessage };
    }

    setUpPaymentIntent(trigger: any, paymentMethodType: string = 'card') {
        // Stripe Elements reports its latest completion state asynchronously from an iframe.
        setTimeout(() => {
            const cardValidation = this.validatecardDetails();
            if (cardValidation.hasError) {
                this.errorSaveCardEvent.emit();
                this._mdlSnackbarService.showSnackbar(cardValidation.errorMessage, 'error');
                return;
            }
            const postData: any = {
                payment_method_type: paymentMethodType
            }
            this.onPaymentIntentStart.emit();
            this._stripeAddNewPaymentService.getStripePaymentIntent(postData).subscribe((res: any) => {
                this.clientSecret = res.data.client_secret;
                this.onCardSave(trigger);

            });
        }, 0);
    }

    async onCardSave(trigger: any) {
        if (!this.clientSecret) {
            this.errorSaveCardEvent.emit();
            this._mdlSnackbarService.showSnackbar('SOMETHING_WENT_WRONG', 'error');
            return;
        }

        try {
            const { setupIntent, error } = await this.Stripe3.confirmCardSetup(
                this.clientSecret,
                {
                    payment_method: {
                        card: this.cardNumber,
                        billing_details: {
                            name: this.cardData.name,
                        }
                    }
                }
            );

            // Run inside Angular zone after Stripe returns
            this._ngZone.run(() => {
                // attachment fails error handling with specific reasons
                if (error) {
                    this.errorSaveCardEvent.emit();
                    const errorCodes = ['incorrect_cvc', 'expired_card', 'card_declined', 'processing_error', 'setup_intent_authentication_failure'];
                    if (errorCodes.includes(error.code)) {
                        this.cardDeclined = true;
                        this.onCardDeclined.emit(this.cardDeclined);
                    }
                    this._mdlSnackbarService.showSnackbar(error.message, 'error');
                    return;
                }

                // successsful card setup and attachment to customer
                if (setupIntent && setupIntent.status === 'succeeded') {
                    this.confirmCardSave(setupIntent.payment_method, trigger);
                }
            })


        } catch (err) {
            this._mdlSnackbarService.showSnackbar('SOMETHING_WENT_WRONG', 'error');
        }
    }

    confirmCardSave(paymentMethod: any, trigger: any) {
        const postData: any = {
            payment_method_id: paymentMethod,
        }
        if (trigger === 'addCard') {
            postData.make_primary = this.makePrimary;
        }
        this._stripeAddNewPaymentService.confirmPaymentMethod(postData).subscribe({
            next: (res: any) => {
                const data = {
                    trigger: trigger,
                    res: res.data,
                    delete_if_failed: true
                }
                this.onCardSaveEvent.emit(data);
            },
            error: (error: any) => {
                if (error?.error_code === 215) {
                    if (trigger === 'addCard') {
                        this.cardDeclined = true;
                        this.errorSaveCardEvent.emit();
                        this._mdlSnackbarService.showSnackbar('DUPLICATE_CARD_ERROR', 'error');
                    } else {
                        const data = {
                            trigger: trigger,
                            res: error.extra
                        }
                        this.onCardSaveEvent.emit(data);
                    }
                } else {
                    this.errorSaveCardEvent.emit();
                    this._mdlSnackbarService.showSnackbar('SOMETHING_WENT_WRONG', 'error');
                }
            }
        });
    }
}